import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "./AppSidebar"
import { PaymentGraceBanner } from "./PaymentGraceBanner"

interface SidebarLayoutProps {
  children: React.ReactNode
}

export function SidebarLayout({ children }: SidebarLayoutProps) {
  // Custom sidebar width for LinkedIn Lina platform
  const style = {
    "--sidebar-width": "14rem",       // 224px - schmaler für mehr Content-Platz
    "--sidebar-width-icon": "3rem",   // schmalere Icon-Breite
  }

  return (
    <SidebarProvider style={style as React.CSSProperties}>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <div className="flex flex-col flex-1 min-w-0">
          <header className="flex items-center justify-between p-2 border-b bg-background">
            <SidebarTrigger data-testid="button-sidebar-toggle" />
          </header>
          <PaymentGraceBanner />
          <main className="flex-1 overflow-auto min-w-0">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  )
}